import {
  DefaultOptions,
  QueryClient,
} from '@tanstack/react-query';

import { shouldRetryQuery } from './should-retry-query';

const queryConfig: DefaultOptions = {
  queries: {
    useErrorBoundary: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: 1000 * 60,
    retry: shouldRetryQuery,
  },
};

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
});

